/*
 * Copy Measurement Point Tab modal - docks to the right of the ADD MEASUREMENTS modal
 */

import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import {
    copyMeasurementPointTab,
    getMeasurementPointList,
    getMeasurementPointListSummaries,
    toggleCopyMeasurementPointTabModal
} from '../../actions/manageMeasurementPointListsActions';
import { CopyMeasurementPointTabForm } from './CopyMeasurementPointTabForm';
import { WithCommonModal } from '../common/WithCommonModal';
import { initialMeasurementPointTab } from '../../reducers/initialState';
import { selectIsLoading } from '../../reducers/commonReducers';
import { IinitialState } from '../../reducers';

interface Iprops {
    colorButton: string;
}

const mapStateToProps = (
    state: IinitialState,
    ownProps: Iprops & WithTranslation
) => {
    const selectedMPL =
        state.manageMeasurementPointLists.selectedMeasurementPointList;
    const selectedTab =
        selectedMPL.measurementPointTabs.find(
            tab => tab.id === state.manageMeasurementPointLists.selectedTabID
        ) || initialMeasurementPointTab;

    return {
        title: ownProps.t('copyTabModalTitle'),
        className: 'copy-tab',
        secondModal: true,
        loading: selectIsLoading(state),
        show:
            state.manageMeasurementPointLists.showCopyMeasurementPointTabModal,
        selectedMeasurementPointList: selectedMPL,
        selectedTab,
        summaries:
            state.manageMeasurementPointLists.measurementPointListSummaries,
        mainCategoryOptions: state.productInfo.mainCategoryOptions,
        standardOptions: state.productInfo.standardOptions
    };
};

export const CopyMeasurementPointTabModal = withTranslation(
    'manageMeasurementPointLists'
)(
    connect(mapStateToProps, {
        onHide: toggleCopyMeasurementPointTabModal,
        toggleModal: toggleCopyMeasurementPointTabModal,
        getMeasurementPointListSummaries,
        copyMeasurementPointTab,
        getMeasurementPointList
    })(WithCommonModal(CopyMeasurementPointTabForm))
);
